var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"opc-price-bill-text-tips",class:[_vm.mxIsSimplifyForProEdit ? 'opc-price-bill-text-tips-simplify' : '']},[_vm._v(" "+_vm._s(_vm.$t("billing.payment_tips"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }